<script setup>
    import {
        ArrowPathIcon,
        ExclamationTriangleIcon,
        ShieldCheckIcon,
        ShieldExclamationIcon,
        XMarkIcon,
    } from '@heroicons/vue/24/solid'
    import { onMounted, onUnmounted, ref } from 'vue'

    const props = defineProps({
        message: {
            type: Object,
            required: true,
        },
        duration: {
            type: Number,
            default: 6000,
        },
    })

    const emit = defineEmits(['remove'])

    const timeoutId = ref(null)

    onMounted(() => {
        timeoutId.value = setTimeout(() => {
            emit('remove')
        }, props.duration)
    })

    onUnmounted(() => {
        if (timeoutId.value) {
            clearTimeout(timeoutId.value)
        }
    })

    function handleRemove() {
        if (timeoutId.value) {
            clearTimeout(timeoutId.value)
        }
        emit('remove')
    }

    const alert = props.message
</script>
<template>
    <div
        class="flex items-center rounded-lg bg-white p-4 text-gray-500 shadow transition-all duration-300 hover:shadow-lg"
        role="alert"
    >
        <div
            class="inline-flex flex-shrink-0 items-center justify-center rounded-lg p-1"
            :class="
                {
                    success: 'bg-green-100',
                    update: 'bg-blue-100',
                    delete: 'bg-red-100',
                    warning: 'bg-yellow-100',
                    error: 'bg-red-100',
                }[alert.type]
            "
        >
            <component
                :is="
                    {
                        success: ShieldCheckIcon,
                        update: ArrowPathIcon,
                        delete: ShieldExclamationIcon,
                        warning: ExclamationTriangleIcon,
                        error: ExclamationTriangleIcon,
                    }[alert.type]
                "
                class="size-8"
                :class="
                    {
                        success: 'text-green-500',
                        update: 'text-blue-500',
                        delete: 'text-red-500',
                        warning: 'text-yellow-500',
                        error: 'text-red-500',
                    }[alert.type]
                "
            />
        </div>

        <div class="mr-2 ml-3 flex-1 text-sm">
            <div
                v-if="alert.title"
                class="font-semibold text-gray-900"
            >
                {{ alert.title }}
            </div>
            <div
                class="text-gray-600"
                :class="{ 'mt-1': alert.title }"
            >
                {{ alert.description }}
            </div>
        </div>

        <button
            @click="handleRemove"
            type="button"
            class="-mx-1.5 -my-1.5 ml-auto inline-flex h-8 w-8 items-center justify-center rounded-lg bg-gray-100 p-1.5 text-gray-400 transition-colors hover:bg-gray-200 hover:text-gray-900 focus:ring-2 focus:ring-gray-300 focus:outline-none"
            aria-label="Close"
        >
            <span class="sr-only">Zavřít</span>
            <XMarkIcon class="h-4 w-4" />
        </button>
    </div>
</template>
